




type HeroTitleComponentProps = {
    isIcon?: boolean;
    icon: string;
    text: string
}

export default function HeroTitleComponent({
    icon,
    text,
    isIcon
 } : Readonly<HeroTitleComponentProps>) {
  
  return (
    <div className="hero-title">
    <div className="hero-border-top"></div>

    <div className="hero-center-bloc">
        <div className="hero-border-left"></div>
        <div className="hero-title-text">
        <p>{text}</p>
        </div>

        <div className="hero-border-right"></div>
    </div>

        <div className="hero-border-bottom">
        <div className="hero-border-bottom-left"></div>
        <div className="hero-border-bottom-center"></div>
        <div className="hero-border-bottom-right"></div>
    </div>

    <div className="hero-icon">
        {
            isIcon 
            ? <i className={`${icon}`}></i>
            : <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + icon} width={40} height={40}/>
        }
        
    </div>
    </div>
  )
}